import { type MessageDescriptor, defineMessages } from 'react-intl';

const debugMessages: Record<string, MessageDescriptor> = defineMessages({
	debugLabel: {
		id: 'rovo-growth-pulse.insights-feed.debug.label',
		defaultMessage: 'Debug',
		description: 'Label for the debug toggle and debug summary section',
	},
	aiThinking: {
		id: 'rovo-growth-pulse.insights-feed.debug.ai-thinking',
		defaultMessage: 'AI Thinking',
		description: 'Label for the AI thinking/reasoning chain section in debug mode',
	},
	copyLabel: {
		id: 'rovo-growth-pulse.insights-feed.debug.copy',
		defaultMessage: 'Copy',
		description: 'Label for copy to clipboard button',
	},
	copiedLabel: {
		id: 'rovo-growth-pulse.insights-feed.debug.copied',
		defaultMessage: 'Copied!',
		description: 'Label shown after text is copied to clipboard',
	},
	copyDebugReport: {
		id: 'rovo-growth-pulse.insights-feed.debug.copy-debug-report',
		defaultMessage: 'Copy Debug Report',
		description: 'Button label to copy the full debug report to clipboard',
	},
	copyRawResponse: {
		id: 'rovo-growth-pulse.insights-feed.debug.copy-raw-response',
		defaultMessage: 'Copy Raw Response',
		description: 'Button label to copy the raw API response JSON to clipboard',
	},
	durationLabel: {
		id: 'rovo-growth-pulse.insights-feed.debug.duration',
		defaultMessage: 'Duration:',
		description: 'Label for generation duration metric in debug panel',
	},
	attemptsLabel: {
		id: 'rovo-growth-pulse.insights-feed.debug.attempts',
		defaultMessage: 'Attempts:',
		description: 'Label for number of generation attempts in debug panel',
	},
	errorLabel: {
		id: 'rovo-growth-pulse.insights-feed.debug.error',
		defaultMessage: 'Error:',
		description: 'Label for error indicator in debug panel',
	},
	errorYes: {
		id: 'rovo-growth-pulse.insights-feed.debug.error-yes',
		defaultMessage: 'Yes',
		description: 'Indicator that an error occurred during generation',
	},
	generatedLabel: {
		id: 'rovo-growth-pulse.insights-feed.debug.generated',
		defaultMessage: 'Generated: {timestamp}',
		description: 'Label showing when insight group was generated',
	},
	groupsCount: {
		id: 'rovo-growth-pulse.insights-feed.debug.groups-count',
		defaultMessage: '{count} groups',
		description: 'Number of insight groups in debug summary',
	},
	insightsCount: {
		id: 'rovo-growth-pulse.insights-feed.debug.insights-count',
		defaultMessage: '{count} insights',
		description: 'Number of insights in debug summary',
	},
	totalDuration: {
		id: 'rovo-growth-pulse.insights-feed.debug.total-duration',
		defaultMessage: '{duration} total',
		description: 'Total generation duration across all groups',
	},
	toggleDebugMode: {
		id: 'rovo-growth-pulse.insights-feed.debug.toggle-debug-mode',
		defaultMessage: 'Toggle debug mode',
		description: 'Accessibility label for the debug toggle switch',
	},
	promptTitle: {
		id: 'rovo-growth-pulse.insights-feed.debug.prompt-title',
		defaultMessage: 'Prompt',
		description: 'Title for the LLM prompt section in debug panel',
	},
	llmResponseTitle: {
		id: 'rovo-growth-pulse.insights-feed.debug.llm-response-title',
		defaultMessage: 'LLM Response',
		description: 'Title for the LLM response section in debug panel',
	},
	charsCount: {
		id: 'rovo-growth-pulse.insights-feed.debug.chars-count',
		defaultMessage: '{title} ({count} chars)',
		description: 'Title with character count for collapsible code block',
	},
	emptyContent: {
		id: 'rovo-growth-pulse.insights-feed.debug.empty-content',
		defaultMessage: '(empty)',
		description: 'Placeholder shown when debug content is empty',
	},
	longestTask: {
		id: 'rovo-growth-pulse.insights-feed.debug.longest-task',
		defaultMessage: 'longest: {title} ({duration})',
		description: 'Shows which group took the longest to generate',
	},
	totalErrors: {
		id: 'rovo-growth-pulse.insights-feed.debug.total-errors',
		defaultMessage: '{count, plural, one {# error} other {# errors}}',
		description: 'Total number of groups that had errors',
	},
	collapseLabel: {
		id: 'rovo-growth-pulse.insights-feed.debug.collapse-label',
		defaultMessage: 'Collapse',
		description: 'Accessibility label for collapsing a section',
	},
	expandLabel: {
		id: 'rovo-growth-pulse.insights-feed.debug.expand-label',
		defaultMessage: 'Expand',
		description: 'Accessibility label for expanding a section',
	},
	summaryLine: {
		id: 'rovo-growth-pulse.insights-feed.debug.summary-line',
		defaultMessage: '{groups} · {insights} · {duration}',
		description: 'Summary line showing groups, insights count and total duration',
	},
	summaryLineWithLongest: {
		id: 'rovo-growth-pulse.insights-feed.debug.summary-line-with-longest',
		defaultMessage: '{groups} · {insights} · {duration} · {longest}',
		description: 'Summary line including longest task info alongside groups and insights',
	},
});

export default debugMessages;
